(function () {
  'use strict';

  var DRAWER_SELECTOR = '#AOV-CDMinimal';
  var LINE_ATTRIBUTE = 'data-pct-club-discount';
  var WIDGET_ATTRIBUTE = 'data-pct-club-vouchers';
  var STORAGE_KEY = 'pctClubDiscountReservation';
  var ACCOUNT_ENDPOINT = '/apps/club-proclean/account';
  var REDEEM_ENDPOINT = '/apps/club-proclean/redeem';
  var RELEASE_ENDPOINT = '/apps/club-proclean/release';
  var syncTimer;
  var syncing = false;
  var releaseInFlight = false;
  var releaseCheckedForEmptyCart = false;
  var releaseRetries = 0;
  var accountCache = null;
  var accountCacheAt = 0;
  var accountRequest = null;
  var actionInFlight = false;
  var selectedVoucherCount = 1;
  var mobileUpsellsExpanded = false;

  function normalized(value) {
    return String(value == null ? '' : value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u2010-\u2015]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function readReservation() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var reservation = JSON.parse(raw);
      var expiresAt = Date.parse(reservation.expiresAt || '');
      if (Number.isFinite(expiresAt) && expiresAt <= Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      reservation.amountCents = Math.max(0, Number(reservation.amountCents || 0));
      reservation.code = String(reservation.code || '');
      return reservation;
    } catch (error) {
      return null;
    }
  }

  function clearReservation() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Le panier reste utilisable si le stockage du navigateur est indisponible.
    }
  }

  function applicationText(application) {
    return normalized([
      application && application.title,
      application && application.description,
      application && application.code
    ].filter(Boolean).join(' '));
  }

  function isClubApplication(application, reservation) {
    var value = applicationText(application);
    var storedCode = normalized(reservation && reservation.code);
    return value.indexOf('club proclean') !== -1 ||
      value.indexOf('pc-') !== -1 ||
      (storedCode && value.indexOf(storedCode) !== -1);
  }

  function amountFromApplication(application) {
    if (!application) return 0;
    var direct = Number(
      application.total_allocated_amount ||
      application.allocated_amount ||
      application.amount ||
      0
    );
    return Number.isFinite(direct) ? Math.max(0, Math.round(direct)) : 0;
  }

  function findClubDiscount(cart) {
    var reservation = readReservation();
    var applications = [];
    var amount = 0;
    var allocatedAmount = 0;
    var matched = false;

    [cart.cart_level_discount_applications, cart.discount_applications].forEach(function (list) {
      if (Array.isArray(list)) applications = applications.concat(list);
    });

    applications.forEach(function (application) {
      if (!isClubApplication(application, reservation)) return;
      matched = true;
      amount = Math.max(amount, amountFromApplication(application));
    });

    (cart.items || []).forEach(function (item) {
      (item.discount_allocations || []).forEach(function (allocation) {
        if (!isClubApplication(allocation.discount_application || {}, reservation)) return;
        matched = true;
        allocatedAmount += Math.max(0, Number(allocation.amount || 0));
      });
    });

    amount = Math.max(amount, allocatedAmount);

    if (matched && amount <= 0 && reservation) amount = reservation.amountCents;

    if (!matched && reservation && reservation.amountCents > 0) {
      var totalDiscount = Math.max(0, Number(cart.total_discount || 0));
      var originalTotal = Math.max(0, Number(cart.original_total_price || 0));
      var total = Math.max(0, Number(cart.total_price || 0));
      if (totalDiscount >= reservation.amountCents && originalTotal - total >= reservation.amountCents) {
        matched = true;
        amount = reservation.amountCents;
      }
    }

    if (!matched || amount <= 0) return null;
    var cartDiscount = Math.max(0, Number(cart.total_discount || 0));
    return {
      amountCents: cartDiscount > 0 ? Math.min(amount, cartDiscount) : amount
    };
  }

  function formatEuros(cents) {
    return (Number(cents || 0) / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function formatDate(value) {
    var date = new Date(value || '');
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function requestJson(url, options) {
    return window.fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok) {
          var error = new Error(payload.error || payload.description || 'Une erreur est survenue.');
          error.status = response.status;
          throw error;
        }
        return payload;
      });
    });
  }

  function cartDiscountCodes(cart, excludedCode) {
    var excluded = normalized(excludedCode);
    var codes = [];
    [cart.cart_level_discount_applications, cart.discount_applications].forEach(function (list) {
      (Array.isArray(list) ? list : []).forEach(function (application) {
        if (normalized(application.type) !== 'discount_code') return;
        var code = String(application.code || application.title || '').trim();
        if (!code || normalized(code) === excluded || normalized(code).indexOf('pc-') === 0) return;
        if (codes.indexOf(code) === -1) codes.push(code);
      });
    });
    return codes;
  }

  function updateCartDiscounts(codes) {
    return requestJson(cartRoute('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: (codes || []).join(',') })
    });
  }

  function invalidateAccount() {
    accountCache = null;
    accountCacheAt = 0;
    accountRequest = null;
  }

  function loadAccount(force) {
    if (!force && accountCache && Date.now() - accountCacheAt < 15000) {
      return Promise.resolve(accountCache);
    }
    if (!force && accountRequest) return accountRequest;

    accountRequest = requestJson(ACCOUNT_ENDPOINT, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (summary) {
        accountCache = { authenticated: true, summary: summary };
        accountCacheAt = Date.now();
        return accountCache;
      })
      .catch(function (error) {
        if (error.status === 401) {
          accountCache = { authenticated: false, summary: null };
          accountCacheAt = Date.now();
          return accountCache;
        }
        throw error;
      })
      .finally(function () { accountRequest = null; });

    return accountRequest;
  }

  function ensureStyles() {
    if (document.getElementById('PctClubCartStyles')) return;
    var style = document.createElement('style');
    style.id = 'PctClubCartStyles';
    style.textContent = [
      '[data-pct-club-vouchers]{margin:12px 0;padding:13px;border:1px solid #b9ddc2;border-radius:12px;background:linear-gradient(135deg,#f6fbf7,#eef8f1);color:#1f3025;font:inherit}',
      '[data-pct-club-vouchers] *{box-sizing:border-box}',
      '.pct-club-cart__head{display:flex;align-items:center;justify-content:space-between;gap:10px}',
      '.pct-club-cart__title{display:flex;align-items:center;gap:8px;font-size:14px;font-weight:800;color:#177b37}',
      '.pct-club-cart__badge{display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:24px;padding:0 7px;border-radius:999px;background:#dff3e4;color:#177b37;font-size:12px;font-weight:800}',
      '.pct-club-cart__summary{margin:8px 0 0;font-size:12px;line-height:1.45;color:#48584e}',
      '.pct-club-cart__list{display:grid;gap:4px;margin:9px 0 0;padding:0;list-style:none}',
      '.pct-club-cart__list li{display:flex;justify-content:space-between;gap:8px;font-size:11px;color:#536359}',
      '.pct-club-cart__controls{display:grid;grid-template-columns:auto minmax(96px,1fr);gap:8px;margin-top:11px}',
      '.pct-club-cart__stepper{display:grid;grid-template-columns:34px 38px 34px;align-items:center;border:1px solid #b9ddc2;border-radius:8px;background:#fff;overflow:hidden}',
      '.pct-club-cart__stepper button{height:36px;border:0;background:#fff;color:#177b37;font-size:18px;font-weight:800;cursor:pointer}',
      '.pct-club-cart__stepper output{text-align:center;font-size:13px;font-weight:800}',
      '.pct-club-cart__apply,.pct-club-cart__login{display:flex;min-height:36px;align-items:center;justify-content:center;border:0;border-radius:8px;background:#2eaa58;color:#fff!important;font-size:12px;font-weight:800;text-decoration:none;cursor:pointer}',
      '.pct-club-cart__apply[disabled],.pct-club-cart__stepper button[disabled]{cursor:not-allowed;opacity:.55}',
      '.pct-club-cart__feedback{min-height:16px;margin:7px 0 0;font-size:11px;line-height:1.35;color:#536359}',
      '.pct-club-cart__feedback[data-error=true]{color:#a12622}',
      '.pct-club-cart__applied{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:9px;padding:9px 10px;border-radius:8px;background:#fff}',
      '.pct-club-cart__applied strong{font-size:13px;color:#177b37}',
      '.pct-club-cart__remove{border:1px solid #cfddd2;border-radius:7px;background:#fff;color:#47564c;font-size:11px;font-weight:700;padding:7px 9px;cursor:pointer}',
      '@media(max-width:420px){.pct-club-cart__controls{grid-template-columns:1fr}.pct-club-cart__stepper{width:106px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function enhanceMobileDrawer(drawer) {
    if (!drawer) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    drawer.classList.toggle('pct-mobile-cart', mobile);

    var container = drawer.querySelector('.AOV-MinimalUpsellProducts__Container');
    if (!container || !container.parentElement) return;
    var wrapper = container.parentElement;
    var cartContent = drawer.querySelector('.AOV-CDMinimal__Content');
    var toggle = wrapper.querySelector('[data-pct-mobile-upsells-toggle]');

    wrapper.setAttribute('data-pct-mobile-upsells', '');
    if (cartContent && cartContent.parentElement === wrapper.parentElement && wrapper.nextElementSibling !== cartContent) {
      cartContent.parentElement.insertBefore(wrapper, cartContent);
    }
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.setAttribute('data-pct-mobile-upsells-toggle', '');
      toggle.innerHTML = '<span>Ajouter un produit complémentaire</span><span aria-hidden="true">+</span>';
      wrapper.insertBefore(toggle, container);
      toggle.addEventListener('click', function () {
        mobileUpsellsExpanded = !mobileUpsellsExpanded;
        container.hidden = !mobileUpsellsExpanded;
        toggle.setAttribute('aria-expanded', mobileUpsellsExpanded ? 'true' : 'false');
        toggle.lastElementChild.textContent = mobileUpsellsExpanded ? '−' : '+';
      });
    }

    container.hidden = !mobileUpsellsExpanded;
    toggle.setAttribute('aria-expanded', mobileUpsellsExpanded ? 'true' : 'false');
    var symbol = mobileUpsellsExpanded ? '−' : '+';
    if (toggle.lastElementChild.textContent !== symbol) toggle.lastElementChild.textContent = symbol;
  }

  function findSubtotalRow(drawer) {
    var candidates = Array.prototype.slice.call(
      drawer.querySelectorAll('div, p, span, strong')
    ).filter(function (element) {
      var value = normalized(element.textContent);
      return /^sous-?total ht\s*:?/.test(value) || /^sous total ht\s*:?/.test(value);
    });

    candidates.sort(function (left, right) {
      return left.textContent.length - right.textContent.length;
    });

    if (!candidates.length) return null;
    var label = candidates[0];
    var row = label;
    while (row.parentElement && row.parentElement !== drawer) {
      var parent = row.parentElement;
      var parentText = normalized(parent.textContent);
      if (parentText.length > normalized(row.textContent).length + 80) break;
      if (parent.children.length > 5) break;
      row = parent;
      if (row.getBoundingClientRect().width > drawer.getBoundingClientRect().width * 0.7) break;
    }
    return row;
  }

  function removeLine(drawer) {
    var line = drawer && drawer.querySelector('[' + LINE_ATTRIBUTE + ']');
    if (line) line.remove();
  }

  function renderLine(drawer, discount) {
    if (!drawer) return;
    if (!discount) {
      removeLine(drawer);
      return;
    }

    var anchor = findSubtotalRow(drawer);
    if (!anchor || !anchor.parentNode) return;

    var amountText = '−' + formatEuros(discount.amountCents) + ' HT';
    var line = drawer.querySelector('[' + LINE_ATTRIBUTE + ']');
    if (!line) {
      line = document.createElement('div');
      line.setAttribute(LINE_ATTRIBUTE, '');
      line.setAttribute('role', 'status');
      line.innerHTML = '<span>Réduction fidélité Club Procleantools</span><strong></strong>';
      anchor.parentNode.insertBefore(line, anchor);
    } else if (line.nextElementSibling !== anchor) {
      anchor.parentNode.insertBefore(line, anchor);
    }

    var amount = line.querySelector('strong');
    if (amount && amount.textContent !== amountText) amount.textContent = amountText;
    line.setAttribute('aria-label', 'Réduction fidélité Club Procleantools : ' + amountText);
  }

  function removeWidget(drawer) {
    var widget = drawer && drawer.querySelector('[' + WIDGET_ATTRIBUTE + ']');
    if (widget) widget.remove();
  }

  function ensureWidget(drawer) {
    var widget = drawer.querySelector('[' + WIDGET_ATTRIBUTE + ']');
    var mobile = window.matchMedia('(max-width: 749px)').matches;

    if (mobile) {
      var cartContent = drawer.querySelector('.AOV-CDMinimal__Content');
      if (!cartContent || !cartContent.parentNode) return null;
      if (!widget) {
        widget = document.createElement('section');
        widget.setAttribute(WIDGET_ATTRIBUTE, '');
        widget.setAttribute('aria-label', 'Bons de fidélité Club Procleantools');
      }
      if (widget.previousElementSibling !== cartContent) {
        cartContent.parentNode.insertBefore(widget, cartContent.nextSibling);
      }
      return widget;
    }

    var anchor = findSubtotalRow(drawer);
    if (!anchor || !anchor.parentNode) return null;
    if (!widget) {
      widget = document.createElement('section');
      widget.setAttribute(WIDGET_ATTRIBUTE, '');
      widget.setAttribute('aria-label', 'Bons de fidélité Club Procleantools');
      anchor.parentNode.insertBefore(widget, anchor);
    } else if (widget.nextElementSibling !== anchor) {
      anchor.parentNode.insertBefore(widget, anchor);
    }
    return widget;
  }

  function widgetFeedback(widget, message, isError) {
    var feedback = widget && widget.querySelector('[data-pct-club-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.setAttribute('data-error', isError ? 'true' : 'false');
  }

  function announceCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function reservationPayload(payload) {
    return {
      code: payload.discount_code || '',
      amountCents: Number(payload.amount_cents || 0),
      expiresAt: payload.expires_at || '',
      voucherCount: Number(payload.vouchers_reserved || 0)
    };
  }

  function saveReservation(payload) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(reservationPayload(payload)));
    } catch (error) {
      // Le bon reste utilisable si le stockage local est bloqué.
    }
  }

  function releaseCreatedDiscount(payload, preservedCodes) {
    clearReservation();
    return updateCartDiscounts(preservedCodes)
      .catch(function () { return null; })
      .then(function () {
        return requestJson(RELEASE_ENDPOINT, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount_code: payload && payload.discount_code || '' })
        }).catch(function () { return null; });
      });
  }

  function applyVouchers(drawer, cart, steps) {
    if (actionInFlight || !steps) return;
    var widget = drawer.querySelector('[' + WIDGET_ATTRIBUTE + ']');
    var button = widget && widget.querySelector('[data-pct-club-apply]');
    var preservedCodes = cartDiscountCodes(cart, '');
    var created = null;

    actionInFlight = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    widgetFeedback(widget, 'Préparation de votre bon sécurisé…', false);

    requestJson(REDEEM_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ steps: steps })
    })
      .then(function (payload) {
        created = payload;
        saveReservation(payload);
        return updateCartDiscounts(preservedCodes.concat(payload.discount_code));
      })
      .then(function (updatedCart) {
        var applied = findClubDiscount(updatedCart);
        if (!applied) throw new Error('Le bon n’a pas pu être appliqué à ce panier.');
        invalidateAccount();
        renderLine(drawer, applied);
        widgetFeedback(widget, 'Votre bon a été appliqué.', false);
        announceCartUpdated(updatedCart);
        scheduleSync(80);
      })
      .catch(function (error) {
        var rollback = created
          ? releaseCreatedDiscount(created, preservedCodes)
          : Promise.resolve();
        return rollback.finally(function () {
          invalidateAccount();
          widgetFeedback(widget, error.message || 'Le bon n’a pas pu être appliqué.', true);
          scheduleSync(300);
        });
      })
      .finally(function () {
        actionInFlight = false;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  function removeVoucherDiscount(drawer, cart) {
    if (actionInFlight) return;
    var widget = drawer.querySelector('[' + WIDGET_ATTRIBUTE + ']');
    var button = widget && widget.querySelector('[data-pct-club-remove]');
    var reservation = readReservation();
    var preservedCodes = cartDiscountCodes(cart, reservation && reservation.code);

    actionInFlight = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    widgetFeedback(widget, 'Retrait du bon…', false);

    updateCartDiscounts(preservedCodes)
      .then(function (updatedCart) {
        return requestJson(RELEASE_ENDPOINT, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount_code: reservation ? reservation.code : '' })
        }).then(function (payload) {
          clearReservation();
          invalidateAccount();
          renderLine(drawer, null);
          announceCartUpdated(updatedCart);
          var restored = Number(payload.released_vouchers || 0);
          widgetFeedback(widget, restored > 0 ? 'Votre bon est de nouveau disponible.' : 'Le bon a été retiré.', false);
          scheduleSync(80);
        });
      })
      .catch(function (error) {
        widgetFeedback(widget, error.message || 'Le bon n’a pas pu être retiré.', true);
      })
      .finally(function () {
        actionInFlight = false;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  function renderVoucherWidget(drawer, cart, account) {
    if (Number(cart.item_count || 0) <= 0) {
      removeWidget(drawer);
      return;
    }

    ensureStyles();
    var discount = findClubDiscount(cart);

    if (discount) {
      var appliedWidget = ensureWidget(drawer);
      if (!appliedWidget) return;
      appliedWidget.innerHTML =
        '<div class="pct-club-cart__head">' +
          '<span class="pct-club-cart__title">Club Procleantools <span class="pct-club-cart__badge">✓</span></span>' +
        '</div>' +
        '<div class="pct-club-cart__applied">' +
          '<div><strong>Bon appliqué : −' + formatEuros(discount.amountCents) + ' HT</strong>' +
          '<p class="pct-club-cart__summary">La remise sera confirmée avec votre commande.</p></div>' +
          '<button class="pct-club-cart__remove" type="button" data-pct-club-remove>Retirer</button>' +
        '</div>' +
        '<p class="pct-club-cart__feedback" data-pct-club-feedback role="status" aria-live="polite"></p>';
      appliedWidget.querySelector('[data-pct-club-remove]').addEventListener('click', function () {
        removeVoucherDiscount(drawer, cart);
      });
      return;
    }

    if (!account || !account.authenticated) {
      removeWidget(drawer);
      return;
    }

    var summary = account.summary || {};
    var vouchers = Array.isArray(summary.vouchers) ? summary.vouchers : [];
    var voucherCount = vouchers.length;
    if (!voucherCount) {
      removeWidget(drawer);
      return;
    }

    var widget = ensureWidget(drawer);
    if (!widget) return;
    var voucherCents = vouchers.length ? Number(vouchers[0].amount_cents || 500) : 500;
    var subtotalCents = Math.max(0, Number(
      cart.items_subtotal_price || cart.original_total_price || cart.total_price || 0
    ));
    var maxByCart = Math.floor(subtotalCents / (voucherCents * 10));
    var eligible = Math.max(0, Math.min(voucherCount, maxByCart));
    selectedVoucherCount = Math.max(1, Math.min(selectedVoucherCount, eligible || 1));

    var preview = vouchers.slice(0, 3).map(function (voucher, index) {
      var expiry = formatDate(voucher.expires_at);
      return '<li><span>Bon ' + (index + 1) + ' · ' + formatEuros(voucher.amount_cents || voucherCents) + ' HT</span>' +
        '<span>' + (expiry ? 'Valable jusqu’au ' + expiry : '') + '</span></li>';
    }).join('');
    if (voucherCount > 3) {
      preview += '<li><span>+' + (voucherCount - 3) + ' autre' + (voucherCount - 3 > 1 ? 's' : '') + ' bon' + (voucherCount - 3 > 1 ? 's' : '') + '</span><span></span></li>';
    }

    var controls = '';
    var message = '';
    if (!eligible) {
      var missing = Math.max(0, voucherCents * 10 - subtotalCents);
      message = 'Ajoutez encore ' + formatEuros(missing) + ' HT au panier pour utiliser un bon.';
    } else {
      controls =
        '<div class="pct-club-cart__controls">' +
          '<div class="pct-club-cart__stepper" aria-label="Nombre de bons à utiliser">' +
            '<button type="button" data-pct-club-minus aria-label="Retirer un bon">−</button>' +
            '<output data-pct-club-count>' + selectedVoucherCount + '</output>' +
            '<button type="button" data-pct-club-plus aria-label="Ajouter un bon">+</button>' +
          '</div>' +
          '<button class="pct-club-cart__apply" type="button" data-pct-club-apply>Utiliser <span data-pct-club-amount>' + formatEuros(selectedVoucherCount * voucherCents) + '</span> HT</button>' +
        '</div>';
      if (eligible < voucherCount) {
        var nextVoucherCount = eligible + 1;
        var missingForNext = Math.max(0, nextVoucherCount * voucherCents * 10 - subtotalCents);
        message = 'Vous pouvez utiliser ' + eligible + ' bon' + (eligible > 1 ? 's' : '') +
          ' maintenant. Ajoutez encore ' + formatEuros(missingForNext) +
          ' HT pour en utiliser ' + nextVoucherCount + '.';
      } else {
        message = 'Tous vos bons sont utilisables dans la limite de 10 % du panier HT.';
      }
    }

    widget.innerHTML =
      '<div class="pct-club-cart__head">' +
        '<span class="pct-club-cart__title">Vos bons Club Procleantools</span>' +
        '<span class="pct-club-cart__badge">' + voucherCount + '</span>' +
      '</div>' +
      '<p class="pct-club-cart__summary">' + message + '</p>' +
      (preview ? '<ul class="pct-club-cart__list">' + preview + '</ul>' : '') +
      controls +
      '<p class="pct-club-cart__feedback" data-pct-club-feedback role="status" aria-live="polite"></p>';

    if (!eligible) return;
    var countOutput = widget.querySelector('[data-pct-club-count]');
    var amountOutput = widget.querySelector('[data-pct-club-amount]');
    var minus = widget.querySelector('[data-pct-club-minus]');
    var plus = widget.querySelector('[data-pct-club-plus]');
    var apply = widget.querySelector('[data-pct-club-apply]');

    function updateSelection(next) {
      selectedVoucherCount = Math.max(1, Math.min(eligible, next));
      countOutput.textContent = selectedVoucherCount;
      amountOutput.textContent = formatEuros(selectedVoucherCount * voucherCents);
      minus.disabled = selectedVoucherCount <= 1;
      plus.disabled = selectedVoucherCount >= eligible;
    }

    minus.addEventListener('click', function () { updateSelection(selectedVoucherCount - 1); });
    plus.addEventListener('click', function () { updateSelection(selectedVoucherCount + 1); });
    apply.addEventListener('click', function () { applyVouchers(drawer, cart, selectedVoucherCount); });
    updateSelection(selectedVoucherCount);
  }

  function releaseReservationForEmptyCart(cart) {
    if (Number(cart.item_count || 0) > 0) {
      releaseCheckedForEmptyCart = false;
      releaseRetries = 0;
      return;
    }
    if (releaseInFlight || releaseCheckedForEmptyCart) return;

    releaseInFlight = true;
    releaseCheckedForEmptyCart = true;
    var reservation = readReservation();
    window.fetch(RELEASE_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount_code: reservation ? reservation.code : ''
      })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.error || 'Annulation indisponible');
          return payload;
        });
      })
      .then(function (payload) {
        clearReservation();
        invalidateAccount();
        releaseRetries = 0;
        document.dispatchEvent(new CustomEvent('club:reservation-released', {
          detail: { releasedPoints: Number(payload.released_points || 0) }
        }));
      })
      .catch(function () {
        if (releaseRetries >= 2) return;
        releaseRetries += 1;
        releaseCheckedForEmptyCart = false;
        window.setTimeout(function () { scheduleSync(0); }, releaseRetries * 2500);
      })
      .finally(function () {
        releaseInFlight = false;
      });
  }

  function syncDiscountLine() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer || syncing) return;
    enhanceMobileDrawer(drawer);
    syncing = true;
    window.fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Panier indisponible');
        return response.json();
      })
      .then(function (cart) {
        renderLine(drawer, findClubDiscount(cart));
        releaseReservationForEmptyCart(cart);
        if (Number(cart.item_count || 0) <= 0) {
          removeWidget(drawer);
          return null;
        }
        return loadAccount(false)
          .then(function (account) {
            renderVoucherWidget(drawer, cart, account);
            enhanceMobileDrawer(drawer);
          })
          .catch(function () {
            removeWidget(drawer);
          });
      })
      .catch(function () {
        removeLine(drawer);
      })
      .finally(function () {
        syncing = false;
      });
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncDiscountLine, delay == null ? 180 : delay);
  }

  function start() {
    var observedDrawer = null;
    var drawerObserver = null;

    function observeDrawer(drawer) {
      if (drawer === observedDrawer) return;
      if (drawerObserver) drawerObserver.disconnect();
      observedDrawer = drawer;
      drawerObserver = null;

      if (!drawer) return;
      drawerObserver = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          if (!mutation.target.closest) return true;
          return !mutation.target.closest('[' + LINE_ATTRIBUTE + '],[' + WIDGET_ATTRIBUTE + ']');
        });
        if (relevant) scheduleSync();
      });
      drawerObserver.observe(drawer, { childList: true, subtree: true, characterData: true });
      scheduleSync(20);
    }

    function nodeContainsDrawer(node) {
      if (!node || node.nodeType !== 1) return false;
      return (node.matches && node.matches(DRAWER_SELECTOR)) ||
        (node.querySelector && node.querySelector(DRAWER_SELECTOR));
    }

    observeDrawer(document.querySelector(DRAWER_SELECTOR));
    scheduleSync(0);
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, nodeContainsDrawer) ||
          Array.prototype.some.call(mutation.removedNodes, nodeContainsDrawer);
      });
      if (relevant || (observedDrawer && !observedDrawer.isConnected)) {
        observeDrawer(document.querySelector(DRAWER_SELECTOR));
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () { scheduleSync(40); });
    window.addEventListener('pageshow', function () {
      observeDrawer(document.querySelector(DRAWER_SELECTOR));
      scheduleSync(40);
    });
    window.addEventListener('resize', function () {
      if (observedDrawer) scheduleSync(40);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
